<template>
  <div>
    <el-card
        v-loading.fullscreen.lock="fullscreenLoading">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">照妖镜工具</span>
      </div>
      <div>
        <el-row :gutter="10">
          <el-col :span="24">
          <span style="color: red;font-size: smaller">
            推客欢迎你使用淘宝工具，如遇到问题， 请联系客服。
          </span>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 2%;">
          <el-col :span="24">
            <el-form ref="vFormData" :model="vFormData" label-width="100px">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="淘宝账号" prop="taobaoAccount">
                    <el-input v-model="vFormData.taobaoAccount" placeholder="淘宝账号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10" style="text-align: center">
                <el-col :span="12">
                  <el-button type="primary" @click="confirmVerify">确认验号</el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card v-show="!isVerifyResult">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">验号结果：</span>
      </div>
      <el-row :gutter="10">
        <el-col :span="6">
          <span>买家：<span style="color: #44b1eb">{{verifyResult.account}}</span></span>
        </el-col>
        <el-col :span="8">
          <span>实名认证：<span style="color: #44b1eb">{{verifyResult.personVerify}}<span style="margin-left: 2%;color: gold;">{{verifyResult.vipLever}}</span></span></span>
        </el-col>
        <el-col :span="4">
          <span>买家信誉：<span style="color: #44b1eb">{{verifyResult.buyerGoodNum}}</span></span>
        </el-col>
        <el-col :span="4">
          <span>好评率：<span style="color: #44b1eb">{{verifyResult.receivedRate}}</span></span>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="10">
        <el-col :span="6">
          <span>淘龄：<span style="color: #44b1eb">{{verifyResult.taoling * 365}}天</span></span>
        </el-col>
        <el-col :span="4">
          <span>性别：<span style="color: #44b1eb">{{verifyResult.gender}}</span></span>
        </el-col>
        <el-col :span="6">
          <span>买家周平均：<span style="color: #44b1eb">{{verifyResult.weekCreditAverage}}</span></span>
        </el-col>
        <el-col :span="8">
          <span>注册日期：<span style="color: #44b1eb">{{verifyResult.wwcreatedStr}}(约{{verifyResult.taoling}}年)</span></span>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {alitaobaoVerifynumber} from "@/api/b2cbusiness/b2c_tasklist";
import {isObjectEmpty} from "@/lib/utils";

export default {
  name: "AliTaobaoVerifyNum",
  data(){
    return {
      fullscreenLoading: false,
      vFormData:{
      },
      verifyResult: {

      }
    }
  },
  computed:{
    isVerifyResult(){
      return isObjectEmpty(this.verifyResult)
    }
  },
  methods:{
    confirmVerify(){
      this.fullscreenLoading = true
      alitaobaoVerifynumber(this.vFormData).then(res=>{
        if (res.success){
          this.verifyResult = res.data;
          this.fullscreenLoading = false
        }
      }).catch(err => {
        this.fullscreenLoading = false
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style scoped>

</style>
